export enum TextboxType {
  TEXT = "text",
  PASSWORD = "password",
  NUMBER = "number",
}
